// @ts-nocheck
import React, {FunctionComponent, useEffect, useState} from "react";
import phoneDevice from "./../../images/mobile_app_stars.jpg";
import appleButton from "./../../images/svgs/cal-64px.svg";
import googleButton from "./../../images/svgs/map-point-64px.svg";
import classNames from "classnames";
import styles from "./Questions.module.scss";
import {useWindowSize} from "../../hooks/use-window-size";
import {fireGA} from "../../hooks/tagging";
import content from "./content";

const Questions: FunctionComponent<{
}> = ({}) => {
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < 768;
    return (<section id="questions" className={classNames([styles.questions, "no-parallax"])}>
            <div>

                <h2 className={styles.headline}>
                    {process.env.REACT_APP_LANG === "spanish" ? content.spanish.headline : content.english.headline}
                </h2>
            </div>
            <div className={styles.mobileButtons}>
                <div>
                    <a
                        onClick={() => fireGA("C1", {innerText: "make an appointment"})} //good
                        href="https://appointments.wellsfargo.com/maa/appointment/"
                        target="_blank"
                        aria-label={process.env.REACT_APP_LANG === "spanish" ? "Haz una cita - abre en una nueva ventana del navegador" : "Make an appointment - opens in a new tab"}
                    >
                        <img
                            alt={process.env.REACT_APP_LANG === "spanish" ? "Ícono de calendario" : "calendar icon"}
                            src={appleButton}
                        />
                        {process.env.REACT_APP_LANG === "spanish" ? "Haz una cita" : "Make an appointment"}
                    </a>
                </div>
                <div>
                    <a
                        onClick={() => fireGA("C2", {innerText: "find a location"})}//good
                        href="https://www.wellsfargo.com/locator/"
                        target="_blank"
                        aria-label={process.env.REACT_APP_LANG === "spanish" ? "Busca una sucursal - abre en una nueva ventana del navegador" : "Find a Location - opens in a new tab"}
                    >
                        <img
                            alt={process.env.REACT_APP_LANG === "spanish" ? " Ícono de marcador de ubicación" : "map location pin icon"}
                            src={googleButton}
                            width={135}
                        />
                        {process.env.REACT_APP_LANG === "spanish" ? "Busca una sucursal" : "Find a location"}
                    </a>
                </div>
            </div>
        </section>);
};

export default Questions;
